var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back",style:({
    backgroundColor: _vm.isSelected ? '#4972f0' : 'unset',
  }),on:{"click":function($event){return _vm.itemClick()}}},[_c('span',{class:this.className,style:({ color: _vm.isSelected ? '#ffffff' : '#64696f' })}),_c('p',{staticClass:"itemTitle",style:({
      color: _vm.isSelected ? '#ffffff' : '#64696f',
    })},[_vm._v(" "+_vm._s(_vm.info.tagName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }